module.exports = {
      id: "ic-uk-100-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-ad374a.smartcharts.svg#ic-uk-100-usage",
      toString: function () {
        return this.url;
      }
    }